export const PurchaseTicketsStyle = {
  wrapper: {
    maxWidth: '970px',
    width: '100%',
    margin: '0 auto',

    '@media (max-width: 639.98px)': {
      padding: '0 20px',
    },
  },

  stepper: {
    width: '100%',
    margin: '40px 0',
    textTransform: 'capitalize',

    '& .MuiTypography-root': {
      lineHeight: '28px',
    },

    '@media (max-width: 639.98px)': {
      margin: '16px 0',
    },
  },

  popup: {
    display: 'flex',
    gap: '16px',
    padding: '20px',
    height: '100%',
    flexDirection: 'column',
  },

  drawer: {
    marginTop: '60px',
    '@media (min-width: 1200px)': {
      display: 'none',
    },
  },
};
